import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { labelCursado } from "components/EspaciosTable/EspaciosTable";

interface Props {
  onClose?: any;
  elemento: EspacioCurricularI | null;
  showModal: boolean;
}

export const EspaciosCurricularesDetailModal = ({
  elemento,
  showModal,
  onClose,
}: Props) => {
  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>{"Detalle espacio curricular:"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col>
            <Row>
              <Col sm={6} className="mb-4">
                <b>Nombre:</b> <br></br>
                {elemento?.nombre}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Descripcion:</b> <br></br>
                {elemento?.descripcion}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Año:</b> <br></br>
                {elemento?.anio}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Horas semanales:</b> <br></br>
                {elemento?.horas_semanales}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Cursado:</b> <br></br>
                {labelCursado(elemento?.cuatrimestre)}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Área de conocimiento:</b> <br></br>
                {elemento?.area?.nombre}
              </Col>

              <hr></hr>

              <Col sm={6} className="mb-4">
                <b>Espacio de formación:</b> <br></br>
                {elemento?.espacio_formacion
                  ? elemento?.espacio_formacion
                  : "No asignado"}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Tipo de espacio:</b> <br></br>
                {elemento?.tipo_espacio.nombre}
              </Col>

              <Col sm={6}>
                <b>Sub tipo:</b> <br></br>
                {elemento?.tipo_espacio.con_sub_tipo
                  ? elemento?.sub_tipo
                  : "Ninguno"}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Nivel:</b> <br></br>
                {elemento?.nivel?.nombre}
              </Col>

              <Col sm={6} className="mb-4">
                <b>Ciclo:</b> <br></br>
                {elemento?.ciclo?.nombre
                  ? elemento?.ciclo?.nombre
                  : "No asignado"}
              </Col>
            </Row>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="mx-3"
            variant="secondary"
            size="lg"
            onClick={onClose}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
